module.exports = __webpack_public_path__ + "static/media/Blogs.fed51a74.jpg";